/* TurnWizard admin — the entry point.
 *
 * The imports below the shell are side-effect imports: each page file registers
 * itself with nav.js and exports nothing anybody here reads. "This import looks
 * unused" is exactly the edit that would remove a page from the sidebar, which
 * is why they are grouped and commented rather than left to look like leftovers.
 *
 * THE ORDER IS THE SIDEBAR. nav.js keeps registration order and groups by first
 * appearance, so this list is the menu, top to bottom:
 *
 *   Salon             Overview · Licence · People · Roles · Danger zone
 *   Console settings  Branding · Board & day · Staff · Services
 *   Connections       Appointments · Optimizer · Ingest keys
 *   Advanced          Advanced · Activity
 *
 * Licence sits second because it is the other half of "what is this salon" —
 * Overview says whether they are working, Licence says what they are entitled
 * to have working — and because People below it is bounded by the seat limit it
 * sets. Roles follows People because it is what People's role menu offers.
 *
 * Overview is first because it is where a link into a salon lands — nav.js falls
 * back to the first registered page for an unknown or missing page id. Danger
 * zone sits at the end of its own group rather than at the end of the menu,
 * because it belongs to the salon rather than to its configuration; alphabetical
 * ordering would have put it second.
 */
import { createApp } from 'vue';

import { App } from './app.js';

/* The salon itself. */
import './pages/overview.js';
import './pages/licensing.js';
import './pages/members.js';
import './pages/roles.js';
import './pages/danger.js';

/* What its console does and looks like. */
import './pages/branding.js';
import './pages/board.js';
import './pages/staff.js';
import './pages/services.js';

/* What it is connected to. */
import './pages/appointments.js';
import './pages/optimizer.js';
import './pages/ingest.js';

/* The escape hatch, and the record. */
import './pages/advanced.js';
import './pages/activity.js';

createApp(App).mount('#app');
